var map = {
	"./awards-carousel": [
		"./src/js/modules/awards-carousel.js",
		[
			"swiper",
			"awards-carousel"
		]
	],
	"./awards-carousel-sidebar": [
		"./src/js/modules/awards-carousel-sidebar.js",
		[
			"swiper",
			"awards-carousel-sidebar"
		]
	],
	"./awards-carousel-sidebar.js": [
		"./src/js/modules/awards-carousel-sidebar.js",
		[
			"swiper",
			"awards-carousel-sidebar"
		]
	],
	"./awards-carousel.js": [
		"./src/js/modules/awards-carousel.js",
		[
			"swiper",
			"awards-carousel"
		]
	],
	"./results-slider-sidebar": [
		"./src/js/modules/results-slider-sidebar.js",
		[
			"swiper",
			"results-slider-sidebar"
		]
	],
	"./results-slider-sidebar.js": [
		"./src/js/modules/results-slider-sidebar.js",
		[
			"swiper",
			"results-slider-sidebar"
		]
	],
	"./team-carousel": [
		"./src/js/modules/team-carousel.js",
		[
			"swiper",
			"team-carousel"
		]
	],
	"./team-carousel.js": [
		"./src/js/modules/team-carousel.js",
		[
			"swiper",
			"team-carousel"
		]
	],
	"./team-sidebar-widget": [
		"./src/js/modules/team-sidebar-widget.js",
		[
			"swiper",
			"team-sidebar-widget"
		]
	],
	"./team-sidebar-widget.js": [
		"./src/js/modules/team-sidebar-widget.js",
		[
			"swiper",
			"team-sidebar-widget"
		]
	],
	"./testimonials-carousel": [
		"./src/js/modules/testimonials-carousel.js",
		[
			"swiper",
			"testimonials-carousel"
		]
	],
	"./testimonials-carousel-sidebar": [
		"./src/js/modules/testimonials-carousel-sidebar.js",
		[
			"swiper",
			"testimonials-carousel-sidebar"
		]
	],
	"./testimonials-carousel-sidebar.js": [
		"./src/js/modules/testimonials-carousel-sidebar.js",
		[
			"swiper",
			"testimonials-carousel-sidebar"
		]
	],
	"./testimonials-carousel.js": [
		"./src/js/modules/testimonials-carousel.js",
		[
			"swiper",
			"testimonials-carousel"
		]
	],
	"./testimonials-videos": [
		"./src/js/modules/testimonials-videos.js",
		[
			"swiper",
			"testimonials-videos"
		]
	],
	"./testimonials-videos.js": [
		"./src/js/modules/testimonials-videos.js",
		[
			"swiper",
			"testimonials-videos"
		]
	],
	"./videos-carousel": [
		"./src/js/modules/videos-carousel.js",
		[
			"swiper",
			"videos-carousel"
		]
	],
	"./videos-carousel.js": [
		"./src/js/modules/videos-carousel.js",
		[
			"swiper",
			"videos-carousel"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/js/modules lazy recursive ^\\.\\/.*$ referencedExports: ";
module.exports = webpackAsyncContext;